<template>
  <div :id="id">
    <form @submit="submit">
      <button type="submit" class="pay-button">PAY WITH CREDIT CARD</button>
    </form>

  </div>
</template>

<script>
export default {
  name: 'CCreditCard',
  props: {
    credits: Number,
    cost: Number,
    index: Number,
    email: String
  },
  data: function () {
    return {
      id: null
    }
  },
  methods: {
    submit (event) {
      event.preventDefault()
      this.$router.push('/credit-card-checkout?credits=' + this.credits + '&amount=' + this.cost)
    }
  }
}
</script>

<style lang="scss">
  .pay-button {
    background: $primary;
    color: #fff;
    font-size: 1.15em;
    border-radius: 4px;
    height: 40px;
    min-height: 40px;
    max-height: 40px;
    max-width: 750px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    border: none;
    vertical-align: top;
    cursor: pointer;
    overflow: hidden;
  }
</style>
